module.exports = __webpack_public_path__ + "img/Neo-Tips-Pic4.34b37fc1.png";